import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const momentoganador = {
	state: {
        dominios : '',
		provincias : '',
		error : '',
		// result: {"esParticipanteNuevo":true,"ganador":true,"necesitaDatosDireccion":true,"datosPremio":{"idPremio":7,"nombre":"Cupón Pizzas Gratis","descripcion":"Cupón Pizzas Gratis","codigo":"FIESTAPJ21","imagen":"img/premio1.png","fisico":false,"conTiradaExtra":false}},
		result : '',
		email : '',
		showTiradaExtra : false,
		lastTirada : window.localStorage.getItem('lastTirada') || null
	},
	getters: {
		getError : state => state.error,
		getProvincias : state => state.provincias,
		getResultParticipacion : state => state.result,
		getEmailParticipacion : state => state.email,
		getLastTirada : state => state.lastTirada,
		getShowTiradaExtra : state => {
			return (!!!state.showTiradaExtra && !!state.result.datosPremio.conTiradaExtra)
		}
	},
	actions: {
		requestDominios : ({commit}, data) => {
			return new Promise((resolve, reject) => {
				axios.get('https://backpromo.fiesta.es/api/dominios/dominios').then( result => {
					if(result.data.status == 0){
                        commit("setDominios", result.data.datos)
                    } 
				}).catch(error => {
					reject(error);
				});  
			});	
		},
		requestProvincias : ({commit}, data) => {
			return new Promise((resolve, reject) => {
				axios.get('https://backpromo.fiesta.es/api/dominios/provincias').then( result => {
					if(result.data.status == 0){
                        commit("setProvincias", result.data.datos)
                    } 
				}).catch(error => {
					reject(error);
				});  
			});	
		},
		sendParticipacion : ({commit}, data) => {
			return new Promise((resolve, reject) => {
				axios.post('https://backpromo.fiesta.es/api/participacion/participar',data).then( result => {
					if(result.data.status == 0){
						resolve(result.data.datos);
						commit('setEmail', data.email);
						commit('setResultadoParticipacion', result.data.datos);
					}else{
						commit("setError",result.data.status);
						resolve(false)
					}
				}).catch(error => {
					reject(error);
				});  
			});	
		},
		sendRegistro : ({commit,getters}, data) => {

			data.email = getters.getEmailParticipacion;

			return new Promise((resolve, reject) => {
				axios.post('https://backpromo.fiesta.es/api/participacion/completaRegistro',data).then( result => {
					if(result.data.status == 0){
						resolve(true);
					}else{
						commit("setError",result.data.status);
						resolve(false);
					}
				}).catch(error => {
					reject(error);
				});  
			});	
        },
        sendDatosPersonales : ({commit,getters}, data) => {

			data.email = getters.getEmailParticipacion;

			return new Promise((resolve, reject) => {
				axios.post('https://backpromo.fiesta.es/api/participacion/completaDatosPersonales',data).then( result => {
					if(result.data.status == 0){
						resolve(true);
					}else{
						commit("setError",result.data.status);
						resolve(false);
					}
				}).catch(error => {
					reject(error);
				});  
			});	
		},
		sendFormularioMomentoGanador: ({commit}, data) => {
			return new Promise((resolve, reject) => {
				axios.post('https://backpromo.fiesta.es/api/participacion/contactar',data).then( result => {
					(result.data.status == 0) ? resolve(true) : reject(false);
				}).catch(error => {
					reject(error);
				});  
			});	
		},
		eraseError:({commit}) => {
				commit('eraseError');
		},
		resetData:({commit}) => {
			commit('resetData');
		},
		setTiradaExtra:({commit,getters},status) => {

			if(getters.getTiradas == 0){}

			setTimeout(e => {
				commit('setTiradaExtra',status)
			},500)
		},
		setLoser:({commit}) => {
			commit('setLoser');
		},
		setLastTirada:({commit}) => {
			commit('setLastTirada')	
		},
		requestTiradaExtra : ({getters,commit}) => {
			return new Promise((resolve, reject) => {
				
				let actual = new Date();
				actual = `${actual.getDate()}-${actual.getMonth()}`;



				let last = (!!getters.getLastTirada) ? new Date(Number(getters.getLastTirada)) : null;

				if(!!last){
					last = `${last.getDate()}-${last.getMonth()}`;
				}
				

				//SI SE PERMITE TIRADA
				if(!!!last || (actual != last)){
					commit("setLastTirada");
					resolve(true);
				}else{
					resolve(false);
					commit("setError",8);
				}

		


			});	
		}

		


	},
	mutations: {
        setDominios(state,dominios){
            state.dominios = dominios;
        },
        setProvincias(state,provincias){
			state.provincias = provincias;
		},
		setError(state,error){
			state.error = error;
		},
		eraseError(state){
			state.error = '';
		},
		setResultadoParticipacion(state, result){
			state.result = result;
		},
		setEmail(state,email){
			state.email = email;
		},
		resetData(state){
			state.result = '';
		},
		setTiradaExtra(state,status){
			state.showTiradaExtra = status;
		},
		setLoser(state){
			state.result.ganador = false;
		},
		setLastTirada(state){
			state.lastTirada = new Date().getTime();
			window.localStorage.setItem("lastTirada",state.lastTirada);
		}
	}
}

export default momentoganador;



// WEBPACK FOOTER //
// ./src/store/momento-ganador.js